import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ConnectedRouter } from 'connected-react-router';
import { OidcProvider } from 'redux-oidc';
import { configureStore } from '@reduxjs/toolkit';
import { ScrollToTop, SecuredApplication, configureAxios } from '@konicaminolta/common-react';
import { history, persistor, store, userManager } from './store/configureStore';
import { unregister } from './registerServiceWorker';
import { appSettings } from './appSettings';
import './scss/app.scss'
import SecuredApplicationPreloader from './pages/Common/SecuredApplicationPreloader';

// Unregistering the service worker to prevent cache issues when new versions are deployed
unregister();

// Exporting to use to create typed hooks
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = ReturnType<typeof configureStore>;

// Configure Axios
configureAxios(store, appSettings);

if (window.location.pathname === `/${appSettings.basePath}/silent-renew`) {
    console.log("silent-renew");
    userManager.signinSilentCallback();
} else {
    ReactDOM.render(
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <OidcProvider store={store} userManager={userManager}>
                    <ConnectedRouter history={history}>
                        <ScrollToTop />
                        <SecuredApplicationPreloader 
                            appSettings={appSettings}
                            userManager={userManager}
                            history={history}
                        />
                    </ConnectedRouter>
                </OidcProvider>
            </PersistGate>
        </Provider>,
        document.getElementById('root'));
}